import React, { useEffect } from "react";
import { GetInvoiceHistory } from "../../../APIServices/SalesService/InvoiceService/invoiceThunk";
import HistoryPage from "../delivery/historyPage";
import { useDispatch } from "react-redux";
const InvoiceHistory = () => {
  const dispatch = useDispatch();
  const status =localStorage.getItem('PAGEData')
  // useEffect(() => {
  //   dispatch(GetInvoiceHistory({ status:status?status:'open',offsetValue}));
  // }, [dispatch]);
  return (
    <HistoryPage
      fetchHistoryThunk={GetInvoiceHistory}
      historySelector={(state) => state.Invoice.InvoiceHistory}
      loadingSelector={(state) => state.Invoice.loading}
      errorSelector={(state) => state.Invoice.error}
      type="invoice"
      tabLabels={{ open: "INCOMPLETED", closed: "PAID" }}
    />
  );
};

export default InvoiceHistory;

// import React, { useState } from 'react';
// import { Tabs, Tab } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
// import HistoryList from '../delivery/historyList';
// import { Toaster } from 'react-hot-toast';
// import { GetInvoiceHistory, GetInvoiceItems } from '../../../APIServices/SalesService/InvoiceService/invoiceThunk';

// const InvoiceHistory = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const storedTab = localStorage.getItem('PAGEData');
//   const [value, setValue] = useState(storedTab ? storedTab : 'Open');

//   const handleChange = (event, newValue) => {
    
//     setValue(newValue);
//     localStorage.setItem('PAGEData', newValue);
//     dispatch(GetInvoiceHistory({status:newValue}))
//   };

//   return (
//     <>
//       <section style={{ width: '100%' }}>
//         <Tabs value={value} onChange={handleChange} className="custom-tabs">
//           <Tab value="Open" label="OVERDUE" />
//           <Tab value="Closed" label="PAID" />
//         </Tabs>

//         <HistoryList
//           type="invoice"
//           status={value}
//           getHistory={GetInvoiceHistory}
//         />
//       </section>

//       <Toaster
//         position="top-center"
//         toastOptions={{
//           style: { fontSize: '16px', padding: '16px', width: '400px', borderRadius: '8px' },
//         }}
//       />
//     </>
//   );
// };

// export default InvoiceHistory;